/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Deletemodal from "./DeleteModal";
import Page from "src/components/Page";
import {
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import Select from "react-select";
import { Add, ArrowLeft, DeleteSharp, EditSharp, UploadFile } from "@mui/icons-material";
import DataTable from "react-data-table-component";
import { notification } from "src/utils/messages";
import { Routes } from "src/constant/api_url";
import { fetchPrimeTrainingWebinarList } from "src/utils/common";
import styled from "styled-components";
import moment from "moment";
import { CSVLink } from "react-csv";
import {
  deleteTrainingWebinar,
  insertPrimeTrainingWebinar,
  updatePrimeTrainingWebinar
} from "src/api/commonapi";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CustomLoader from "src/components/CustomLoader";

export default function TrainingAndWebinar() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [page, setPage] = useState(0);
  const handlePageChange = (newPageValue) => {
    setPage(newPageValue);
  };

  const [setfile, setFile] = useState({});
  const [fileimage, setfileimage] = useState();
  const [loading, setLoading] = useState(false);
  const [newTrainingWebinarList, setNewTrainingWebinarList] = useState([]);
  const [trainingWebinarList, setTrainingWebinarList] = useState([]);
  const [response, setresponse] = useState(0);
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1
  });

  const [formData, setFormData] = useState({
    t_w_img: "",
    t_w_title: "",
    t_w_desc: "",
    t_w_link: "",
    t_w_button_title: "",
    t_w_sdate: "",
    t_w_edate: "",
    t_w_send_to: "2", //	0-all, 1-LT, 2-members
    t_w_for_type: "4", // 0 - LVB , 1- State, 2- City, 3- Chapter, 4- Prime
    t_w_for_type_id: ""
  });

  const resetFormData = () => {
    setFormData({
      t_w_img: "",
      t_w_title: "",
      t_w_desc: "",
      t_w_link: "",
      t_w_button_title: "",
      t_w_sdate: "",
      t_w_edate: "",
      t_w_send_to: "2", // //	0-all, 1-LT, 2-members
      t_w_for_type: "4", // 0 - LVB , 1- State, 2- City, 3- Chapter, 4- Prime
      t_w_for_type_id: ""
    });
  };

  const TrainingWebinarStatus = [
    { label: "All", value: 0 },
    { label: "Open ", value: 1 },
    { label: "Close", value: 2 }
  ];

  const [filtereddata, setFilteredData] = useState({
    trainingWebinarStatus: 0,
    search: "",
    startDate: "",
    endDate: ""
  });

  const handleFormSubmit = async (newData = undefined) => {
    try {
      let fData = new FormData();

      if (formData != undefined && formData.t_w_id != undefined) {
        if (
          // !setfile ||
          // Object.keys(setfile).length === 0 ||
          // !setfile.file ||
          formData.t_w_title == "" ||
          formData.t_w_desc == "" ||
          formData.t_w_link == "" ||
          formData.t_w_button_title == "" ||
          formData.t_w_sdate == "" ||
          formData.t_w_edate == ""
        ) {
          let notify = notification({
            type: "error",
            message: "Please enter all required fields to submit"
          });
          notify();
        } else {
          fData.append("t_w_title", formData.t_w_title);
          fData.append("t_w_desc", formData.t_w_desc);
          fData.append("t_w_img", setfile.file);
          fData.append("t_w_link", formData.t_w_link);
          fData.append("t_w_button_title", formData.t_w_button_title);
          fData.append("t_w_sdate", formData.t_w_sdate);
          fData.append("t_w_edate", formData.t_w_edate);
          fData.append("t_w_id", formData.t_w_id);
          setLoading(true);

          const resp = await updatePrimeTrainingWebinar(fData);
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          setLoading(false);
          if (resp.status == 1) {
            notify();
            resetFormData();
            setPage(0);
            setFile({});
            setfileimage();
            getTrainingWebinarList();
          } else {
            notify();
          }
        }
      } else {
        // Insert the form data
        if (
          !setfile ||
          Object.keys(setfile).length === 0 ||
          !setfile.file ||
          formData.t_w_title == "" ||
          formData.t_w_desc == "" ||
          formData.t_w_link == "" ||
          formData.t_w_button_title == "" ||
          formData.t_w_sdate == "" ||
          formData.t_w_edate == ""
        ) {
          let notify = notification({
            type: "error",
            message: "Please enter all required fields to submit"
          });
          notify();
        } else {
          // API Call
          fData.append("t_w_title", formData.t_w_title);
          fData.append("t_w_desc", formData.t_w_desc);
          fData.append("t_w_img", setfile.file);
          fData.append("t_w_link", formData.t_w_link);
          fData.append("t_w_button_title", formData.t_w_button_title);
          fData.append("t_w_sdate", formData.t_w_sdate);
          fData.append("t_w_edate", formData.t_w_edate);
          fData.append("t_w_send_to", formData.t_w_send_to);
          fData.append("t_w_for_type", formData.t_w_for_type);
          fData.append("t_w_for_type_id", formData.t_w_for_type_id);
          setLoading(true);
          const resp = await insertPrimeTrainingWebinar(fData);
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          setLoading(false);
          if (resp.status == 1) {
            notify();
            resetFormData();
            setPage(0);
            setFile({});
            setfileimage();
            getTrainingWebinarList();
          } else {
            notify();
          }
        }
      }
    } catch (e) {
      console.log("Error", e);
    }
  };

  const trainingwebinardelete = async (t_w_id) => {
    const resp = await deleteTrainingWebinar(t_w_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };

  const getTrainingWebinarList = async () => {
    setLoading(true);
    setTrainingWebinarList(await fetchPrimeTrainingWebinarList(loginUser.u_type));
    setLoading(false);
  };

  useEffect(async () => {
    getTrainingWebinarList();
  }, [response]);

  const formattedCSVData = newTrainingWebinarList.map((row, index) => ({
    t_w_id: index + 1,
    t_w_title: row.t_w_title,
    t_w_desc: row.t_w_desc,
    t_w_link: row.t_w_link,
    t_w_sdate: row.t_w_sdate,
    t_w_edate: row.t_w_edate
  }));

  const expo_columns = [
    { label: "No", key: "t_w_id" },
    { label: "Title", key: "t_w_title" },
    { label: "Description", key: "t_w_desc" },
    { label: "URL", key: "t_w_link" },
    { label: "Button Title", key: "t_w_button_title" },
    { label: "Start Date", key: "t_w_sdate" },
    { label: "End Date", key: "t_w_edate" }
  ];

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row, index) => index + 1,
      sortable: true,
      width: "50px"
    },
    {
      name: "Image",
      wrap: true,
      width: "150px",
      cell: (row) => {
        return (
          <img
            src={`${Routes.API_HOSTNAME}images/training_webinar/${row.t_w_img}`}
            alt="img"
            width="100"
          />
        );
      }
    },
    {
      name: "Title",
      wrap: true,
      width: "200px",
      selector: (row) => (row.t_w_title != null && row.t_w_title != "" ? row.t_w_title : "-"),
      sortable: true
    },
    {
      name: "URL",
      wrap: true,
      width: "150px",
      selector: (row) => ((row.t_w_link != null) & (row.t_w_link != "") ? row.t_w_link : "-"),
      sortable: true
    },
    {
      name: "Button Title",
      wrap: true,
      width: "150px",
      selector: (row) =>
        (row.t_w_button_title != null) & (row.t_w_button_title != "") ? row.t_w_button_title : "-",
      sortable: true
    },

    {
      name: "Start Date",
      wrap: true,
      width: "120px",
      selector: (row) => row.t_w_sdate,
      sortable: true
    },
    {
      name: "End Date",
      selector: (row) => row.t_w_edate,
      wrap: true,
      width: "120px",
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      width: "150px",
      cell: (row) => (
        <>
          <button
            onClick={() => {
              setPage(2);
              setFormData(row);
              setfileimage();
            }}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            <Tooltip title="Edit">
              <IconButton>
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          </button>
          <button
            onClick={() => {
              setDvisible({ mval: true, id: row.t_w_id });
            }}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            <Tooltip title="Delete">
              <IconButton>
                <DeleteSharp color="error" />
              </IconButton>
            </Tooltip>
          </button>
        </>
      )
    }
  ];

  const ExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        <p>
          <b>Description</b> : {data?.t_w_desc}
        </p>
      </div>
    );
  };

  const filterData = () => {
    const filterByOpenClose = (trainingwebinar) => {
      if (filtereddata.trainingWebinarStatus === 1) {
        // Open trainingWebinar: future trainingWebinar only
        return moment(trainingwebinar.t_w_edate, "DD-MM-YYYY hh:mm A").isSameOrAfter(moment());
      }
      if (filtereddata.trainingWebinarStatus === 2) {
        // Closed trainingWebinar: past trainingWebinar only
        return moment(trainingwebinar.t_w_edate, "DD-MM-YYYY hh:mm A").isBefore(moment());
      }
      return true;
    };

    const filterBySearchType = (trainingwebinar) => {
      let searchFilterText = filtereddata.search.toLowerCase();
      return (
        filtereddata.search == "" ||
        trainingwebinar?.t_w_title?.toLowerCase().includes(searchFilterText) ||
        trainingwebinar?.t_w_desc?.toLowerCase().includes(searchFilterText) ||
        trainingwebinar?.t_w_link?.toLowerCase().includes(searchFilterText)
      );
    };

    const nTrainingWebinar = trainingWebinarList.filter(
      (trainingwebinar) => filterByOpenClose(trainingwebinar) && filterBySearchType(trainingwebinar)
    );

    setNewTrainingWebinarList(nTrainingWebinar);
  };

  useEffect(() => {
    filterData();
  }, [filtereddata, trainingWebinarList]);

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={trainingwebinardelete} />
      <Page title="Training & Webinar | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Training & Webinar
            </Typography>
            {page === 0 ? (
              <Button variant="contained" color="primary" onClick={() => handlePageChange(1)}>
                <Add sx={{ fontSize: "20px", marginRight: "5px" }} />
                Add Training or Webinar
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  resetFormData();
                  setPage(0);
                  setfileimage();
                }}
              >
                <ArrowLeft sx={{ fontSize: "20px", marginRight: "5px" }} />
                Back
              </Button>
            )}
          </Stack>

          {page !== 0 ? (
            <>
              <Card style={{ padding: "20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Button
                      component="label"
                      variant="contained"
                      color="primary"
                      tabIndex={-1}
                      sx={{ textTransform: "none", p: "10px" }}
                      startIcon={<UploadFile />}
                    >
                      Click to Upload file
                      <VisuallyHiddenInput
                        type="file"
                        required
                        multiple={false}
                        accept="image/*,.jpg,.jpeg,.png,.gif"
                        onChange={(event) => {
                          const uploadedFile = event.currentTarget.files[0];

                          // Check if file exists and validate its size
                          if (uploadedFile && uploadedFile.size > 2097152) {
                            let notify = notification({
                              type: "error",
                              message: "File size exceeds 2MB. Please upload a smaller file."
                            });
                            notify();
                            return;
                          }

                          // If valid, update the state
                          setFile({ file: uploadedFile });
                          setfileimage(URL.createObjectURL(uploadedFile));
                        }}
                      />
                    </Button>

                    {/* Display uploaded Image */}
                    {page === 1 &&
                      (fileimage !== undefined ? (
                        <div style={{ marginTop: "10px" }}>
                          <h4>Image Preview</h4>
                          <div className="position-relative">
                            <img
                              src={fileimage}
                              alt="Uploaded file preview"
                              style={{
                                width: "450px",
                                objectFit: "contain",
                                height: "250px",
                                boxShadow: "0 0 5px #ccc",
                                borderRadius: "5px"
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      ))}
                    {page === 2 &&
                      (fileimage !== undefined ? (
                        <div style={{ marginTop: "10px" }}>
                          <h4>Image Preview</h4>
                          <div className="position-relative">
                            <img
                              src={fileimage}
                              alt="Uploaded file preview"
                              style={{
                                width: "450px",
                                objectFit: "contain",
                                height: "250px",
                                boxShadow: "0 0 5px #ccc",
                                borderRadius: "5px"
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <div style={{ marginTop: "10px" }}>
                          <h4>Image Preview</h4>
                          <div className="position-relative">
                            <img
                              src={`${Routes.API_HOSTNAME}images/training_webinar/${formData?.t_w_img}`}
                              alt="Uploaded file preview"
                              style={{
                                width: "450px",
                                objectFit: "contain",
                                height: "250px",
                                boxShadow: "0 0 5px #ccc",
                                borderRadius: "5px"
                              }}
                            />
                          </div>
                        </div>
                      ))}
                  </Grid>

                  <Grid item xs={12}>
                    <Stack spacing={3}>
                      <TextField
                        required
                        type="text"
                        label="Title"
                        fullWidth
                        value={formData?.t_w_title}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            t_w_title: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label="Description"
                      required
                      multiline
                      fullWidth
                      rows={4}
                      value={formData?.t_w_desc}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          t_w_desc: e.target.value
                        });
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Stack spacing={3}>
                      <TextField
                        required
                        type="text"
                        label="URL"
                        fullWidth
                        value={formData?.t_w_link}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            t_w_link: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>

                  {/* grid 6 add start date and end date */}
                  <Grid item xs={4}>
                    <Stack spacing={3}>
                      <TextField
                        required
                        type="text"
                        label="Button Title"
                        fullWidth
                        value={formData?.t_w_button_title}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            t_w_button_title: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={4}>
                    <Stack spacing={3}>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        style={{ marginTop: "20px" }}
                      >
                        <DateTimePicker
                          type="date"
                          name="t_w_sdate"
                          label="Start Date "
                          inputFormat="dd/MM/yyyy hh:mm a"
                          value={
                            formData.t_w_sdate !== ""
                              ? moment(formData.t_w_sdate, "DD-MM-YYYY hh:mm A").toDate()
                              : null
                          }
                          onChange={(newDate) => {
                            setFormData({
                              ...formData,
                              t_w_sdate: moment(newDate).format("DD-MM-YYYY hh:mm A")
                            });
                          }}
                          renderInput={(params) => <TextField {...params} required />}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Grid>
                  <Grid item xs={4}>
                    <Stack spacing={3}>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        style={{ marginTop: "20px" }}
                      >
                        <DateTimePicker
                          type="date"
                          name="t_w_edate"
                          label="End Date "
                          inputFormat="dd/MM/yyyy hh:mm a"
                          value={
                            formData.t_w_edate != ""
                              ? moment(formData.t_w_edate, "DD-MM-YYYY hh:mm A").toDate()
                              : null
                          }
                          onChange={(newDate) => {
                            setFormData({
                              ...formData,
                              t_w_edate: moment(newDate).format("DD-MM-YYYY hh:mm A")
                            });
                          }}
                          renderInput={(params) => <TextField {...params} required />}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Grid>

                  {/* submit and rest form state */}
                  <Grid item xs={12} spacing={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ marginRight: "5px" }}
                      disabled={loading}
                      onClick={() => handleFormSubmit()} // handleFormSubmit function
                      startIcon={loading && <CircularProgress size={20} color="inherit" />}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        resetFormData();
                        setPage(0);
                        setfileimage();
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </>
          ) : (
            <>
              <Card className="p-20 mb-15">
                <Grid container spacing={2} sx={{ alignItems: "center" }}>
                  <Grid item xs={3}>
                    <Stack>
                      <label>Training/Webinar Status</label>
                      <Select
                        menuPortalTarget={document.body}
                        value={TrainingWebinarStatus.map((c) => {
                          if (c.value == filtereddata.trainingWebinarStatus) {
                            return { value: c.value, label: c.label };
                          }
                        })}
                        onChange={(e) => {
                          setFilteredData({
                            ...filtereddata,
                            trainingWebinarStatus: e.value
                          });
                        }}
                        options={TrainingWebinarStatus}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={4}>
                    <Stack spacing={10}>
                      <TextField
                        style={{ marginTop: "0px" }}
                        fullWidth
                        autoComplete="off"
                        type="text"
                        label="Search"
                        name="name"
                        autoCorrect="off"
                        value={filtereddata.search}
                        onChange={(e) => {
                          setFilteredData({
                            ...filtereddata,
                            search: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>

                  <Grid
                    item
                    xs={1}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end"
                    }}
                  >
                    <Button
                      onClick={async () => {
                        setFilteredData({
                          trainingWebinarFor: -1,
                          trainingWebinarStatus: 0,
                          search: "",
                          startDate: "",
                          endDate: ""
                        });
                      }}
                      variant="contained"
                    >
                      clear
                    </Button>
                  </Grid>
                </Grid>
              </Card>
              <Card className="p-2" style={{ padding: "15px" }}>
                <Button className="btn btn-export">
                  <CSVLink
                    data={formattedCSVData}
                    headers={expo_columns}
                    filename={"Training_Webinar.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                {trainingWebinarList && (
                  <>
                    <DataTable
                      filter
                      pagination
                      highlightOnHover
                      columns={columns}
                      data={newTrainingWebinarList != null && newTrainingWebinarList}
                      expandableRows
                      expandableRowsComponent={ExpandableRow}
                      progressPending={loading}
                      progressComponent={<CustomLoader />}
                    />
                  </>
                )}
              </Card>
            </>
          )}
        </Container>
      </Page>
    </>
  );
}
